import { HttpService } from '../../../App/services/http'

export const SynonymService = {
    values,
    remove,
    save,
    filter
}

function values (params) {
    const options = {
        method: 'GET',
        params: params
    }

    return HttpService.http(`/dictionary/synonym/exception/values`, options, true)
        .then(response => {
            return response
        })
}

function remove (params) {
    const options = {
        method: 'DELETE',
        body: JSON.stringify(params)
    }

    return HttpService.http(`/dictionary/synonym/exception/values`, options, true)
        .then(response => {
            return response
        })
}

function save (params) {
    const options = {
        method: 'PUT',
        body: JSON.stringify(params)
    }

    return HttpService.http(`/dictionary/synonym/exception/values`, options, true)
        .then(response => {
            return response
        })
}

function filter (params = {}) {
    const options = {
        method: 'GET',
        params: params
    }

    return HttpService.http(`/dictionary/synonym/exception/values/filter`, options, true)
        .then(response => {
            return response
        })
}

